import React from 'react'
import './Privacypolicy.css'

const Privacypolicy = () => {
  return (
   <div><div class="heading"><h2>Privacy Policy</h2></div>
    <div class="content-container">
   

    <div>
      
    <div class="policycontent-container">
    
<div className='policycontent'>
   <p> Thanks for visiting website of National Institute for Geo-Informatics Science and Technology, Survey of India and reviewing our privacy policy.
    
    As a general rule, this website does not collect any Personal Information about you or anyone who visit the site. Anyone can generally visit the site without revealing Personal Information, unless he chooses to provide such information.</p>
    
    <h4>SITE VISIT DATA</h4>
    
  <p>  This website records only the following information for statistical purposes – visitor's server address; the name of the top-level domain from which visitor access the Internet (for eg, .gov, .com, .in, etc.); the type of browser visitor use; the date and time visitor access the site; the pages visitor have accessed and the documents downloaded and the previous Internet address from which visitor linked directly to the site.
    
    We will not identify users or their browsing activities, except when a law enforcement agency may exercise a warrant to inspect the service provider's logs.</p>
    
    <h4>COOKIES</h4>
    
   <p> A cookie is a piece of software code that an internet web site sends to visitor's browser when he access information at that site. This site does not use cookies.</p>
    
    <h4>EMAIL MANAGEMENT</h4>
    
   <p> Visitor's email address will only be recorded only if he chooses to send a message. It will only be used for the purpose for which they have provided it and will not be added to a mailing list. Visitor's email address will not be used for any other purpose, and will not be disclosed, without their consent.</p>
    
    <h4>COLLECTION OF PERSONAL INFORMATION</h4>
    
   <p> If visitors are asked for any other Personal Information they will be informed how it will be used if visitor choose to give it. If at any time visitor believe the principles referred to in this privacy statement have not been followed, or have any other comments on these principles, please notify the Web Administrator through the contact us page.</p>
     
    <p><span id="note">Note:</span> The use of the term "Personal Information" in this privacy statement refers to any information from which your identity is apparent or can be reasonably ascertained.</p>
    </div>
  </div>
  </div>
</div>
</div>
 
  )
}

export default Privacypolicy
